import { EventEmitter } from 'events';
import dispatcher from './dispatcher';
import { DISMISS, VIEW_QUESTIONS } from './Actions';

class QuestionStore extends EventEmitter {
  constructor() {
    super();
    this.questions = [];
  }

  viewQuestions() {
    return this.questions;
  }

  handleActions(action) {
    console.log(` Handle Actions ${JSON.stringify(action)}`);

    switch (action.type) {
      case VIEW_QUESTIONS:
        this.questions = action.payload;
        this.emit('view_questions');
        break;
      case DISMISS:
        this.emit('change');
        break;
    }
  }
}

const questionStore = new QuestionStore();

dispatcher.register(questionStore.handleActions.bind(questionStore));

export default questionStore;
